import React  from 'react'
import {FieldViewProps} from "../../../render/view"

const debug = false
// const debug = "FieldAddress_View"

export default function FieldAddress_View(props:FieldViewProps) {

    debug && console.log(debug, 'render', props)

    const value = _.get(props.model, props.field.fieldId, null)

    const displayValue = props.field.getDisplayValue(value)

    const classes = Classes("flex-row-left-top txt-truncate", props.className)

    return (
        <div className={classes}>
            {displayValue && <div className="i5-location ui5-ico-16 m-r-5"></div>}
            <div className = "ui5-txt-default txt-truncate">
                {displayValue}
            </div>
        </div>
    )
}
